import { Schema, z } from 'zod';

export type VersionString = `${number}.${number}.${number}`;

const verExpression = /^\d+\.\d+\.\d+$/;

export const VersionStringSchema: Schema<VersionString> =
  z.custom<VersionString>((str) => verExpression.test(str as string));
